<template>
  <div>
    <!-- 这里的权限通过后端来控制是否显示 -->
    <transition>
      <el-menu class="Layout-Nav" :collapse="NavShow"
        background-color="#0074C7" text-color="#ffffff"
        active-text-color="#ffffff"
        :router="true" :default-active="path" v-cloak>
        <!-- 监控大屏 -->
        <el-menu-item index="/cloudMonitor/cloudMonitorHome">
          <i class="icon-shouye iconsize"></i>
          <span slot="title" style="font-size:14px">{{$t('lang.Monitor.MonitorScreen')}}</span>
        </el-menu-item>
        <!-- 设备管理 -->
        <el-submenu index="1" v-if="device.parentId">
          <template slot="title">
            <i class="icon-huabanfuben iconsize"></i>
            <span slot="title">{{$t('lang.menu.device')}}</span>
          </template>
          <el-menu-item 
            index="/cloudMonitor/deviceManagement/fastAccess" 
            v-if="arr.indexOf(213)!=-1" 
            class="Menu-Group">
            {{$t('lang.devicesManagement.FastAccess')}}
          </el-menu-item>
          <el-menu-item 
            index="/cloudMonitor/deviceManagement/projectGroup" 
            v-if="arr.indexOf(214)!=-1" 
            class="Menu-Group">
            {{$t('lang.devicesManagement.ProjectGroup')}}
          </el-menu-item>
          <el-menu-item 
            index="/cloudMonitor/deviceManagement/deviceList" 
            v-if="arr.indexOf(215)!=-1" 
            class="Menu-Group">
            {{$t('lang.devicesManagement.deviceList')}}
          </el-menu-item>
          <el-menu-item 
            index="/cloudMonitor/deviceManagement/terminalList" 
            v-if="arr.indexOf(216)!=-1" 
            class="Menu-Group">
             {{$t('lang.devicesManagement.TerminalList')}}
          </el-menu-item>
                    <el-menu-item 
            index="/cloudMonitor/deviceManagement/variableList" 
            v-if="arr.indexOf(217)!=-1" 
            class="Menu-Group">
            {{$t('lang.devicesManagement.variableList')}}
          </el-menu-item>
          <el-menu-item 
            index="/cloudMonitor/deviceManagement/collectConfigurate" 
            v-if="arr.indexOf(217)!=-1" 
            class="Menu-Group">
            {{$t('lang.devicesManagement.CollectConfigurate')}}
          </el-menu-item>
        </el-submenu>
        <!-- 报警管理 -->
        <el-submenu index="2" v-if="alarm.parentId">
          <template slot="title">
            <i class="icon-lingdang icon-gaojin iconsize"></i>
            <span slot="title">{{$t('lang.alarmManagement.alarmManagement')}}</span>
          </template>
          <el-menu-item 
            index="/cloudMonitor/alarmManagement/alarmNotice" 
            v-if="arr.indexOf(218)!=-1" 
            class="Menu-Group">
            {{$t('lang.alarmManagement.AlarmNotice')}}
          </el-menu-item>
          <el-menu-item 
            index="/cloudMonitor/alarmManagement/alarmContact" 
            v-if="arr.indexOf(219)!=-1" 
            class="Menu-Group">
            {{$t('lang.alarmManagement.AlarmContact')}}
          </el-menu-item>
          <el-menu-item 
            index="/cloudMonitor/alarmManagement/alarmList" 
            v-if="arr.indexOf(264)!=-1" 
            class="Menu-Group">
              {{$t('lang.alarmManagement.AlarmList')}}
          </el-menu-item>
        </el-submenu>
        <!--统计报表-->
        <el-submenu index="4" v-if="statisticalReports.parentId">
          <template slot="title">
            <i class="icon-tongji iconsize"></i>
            <span slot="title">{{$t('lang.menu.graphs')}}</span>
          </template>
            <el-menu-item 
              index="/cloudMonitor/statisticalReports/historyRecords" 
              v-if="arr.indexOf(220)!=-1" 
              class="Menu-Group">
              {{$t('lang.statictics.HistoryRecords')}}
            </el-menu-item>
            <!-- <el-menu-item 
              index="/cloudMonitor/statisticalReports/devicesStatus" 
              v-if="arr.indexOf(80)!=-1" 
              class="Menu-Group">
              {{$t('lang.statictics.DevicesStatus')}}
            </el-menu-item> -->
        </el-submenu>
        
      </el-menu>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {UserGetMenu} from '@/api/nav'
import {setMenu, getMenu} from '@/cookie/cookie'
import { getuser_iscustomer,getuser_ctid } from '@/localStorage/localStorage'
//递归筛选函数
var findInObject = function (dataObj, key) {
  let arr = [];        
  if (typeof dataObj !== 'object') return arr;
  for (let prop in dataObj) {          
    if (prop == key) {
        arr.push(dataObj[key]);
    } else {
        if (Array.isArray(dataObj[prop])) {
            dataObj[prop].forEach((item) => {
                arr = arr.concat(findInObject(item, key))
            });
        }
    }
  }   
  return arr;
}
export default {
  data() {
    return {
      //权限数据
      navlist: [],
      //设备管理
      device: {},
      // //故障管理
      // alarmMsg: {},
      //统计报表
      statisticalReports: {},
      // 报警管理
      alarm: {},
      //监听页面高度达到侧边栏自适应高度,
      arr: [],
      path: this.$route.path,
      navwidth: 12,
      user_iscustomer:getuser_iscustomer(),
      user_ctid:getuser_ctid()
    };
  },
  mounted() {
    UserGetMenu(1).then((res) => { 
      this.arr = findInObject(res.data, 'sonId')
      //获取到菜单权限表
      this.navlist = res.data.queryResult
      //保存到cookie中
      setMenu(res.data)
      //循环遍历匹配
      for (let i = 0; i < this.navlist.length; i++) {
        if (this.navlist[i].parentName == '设备管理' && this.navlist[i].parentId) {
            this.device = this.navlist[i]
        }
        if (this.navlist[i].parentName == '报警管理' && this.navlist[i].parentId) {
            this.alarm = this.navlist[i]
        }
        if (this.navlist[i].parentName == '统计报表' && this.navlist[i].parentId) {
            this.statisticalReports = this.navlist[i]
        }
      }     
    })
  },
  watch: {
    //监听路径变化
    '$route.path'(a, b) {
        this.path = a
    }
  },
  computed: {
      ...mapGetters(['NavShow','Logo'])
    }
}
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    min-height: 7.6rem;
}
.el-menu {
    border: none;
    background-color: #5e5e5f;
}
.con {
    background-color: #5e5e5f;
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: scroll;
    position: fixed;
    z-index: 100;
    transform: scale3d(1, 1, 1);
}
.iconsize {
    color: #f4f4f5;
    margin-right: 0.2rem;
}
.el-submenu .el-menu-item {
    min-width: 0;
}
.con::-webkit-scrollbar {
    display: none;
}
.iconbuttom {
    height: 1rem;
    width: 100%;
    position: fixed;
    z-index: 200;
}
.ilist {
    padding: 0.27rem;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.Layout-Nav{
    height: 100vh;
    /* transition:all 300ms ease-out; */
}
.Layout-Nav::-webkit-scrollbar {
    display: none;
}
.Layout-Nav-Con{
    width: 220px;
    /* height: 10vh; */
    /* gai de  */
    height: 8vh;
    /* border-bottom:4px solid  #eaeaea; */
    border-bottom: none;
    box-sizing: border-box;
    position: fixed;
    z-index: 10;
    background-color: #0074c7;
    display: flex;
}
.Layout-Nav-Con-Show{
    width: 64px;
    /* height: 10vh; */
    /* gai de  */
    height: 8vh;
    /* border-bottom:4px solid  #eaeaea; */
    border-bottom: none;
    box-sizing: border-box;
    position: fixed;
    z-index: 10;
    background-color: #0074c7;
}
.Layout-Nav-Logo{
    width: 75%;
    margin:0 auto 0 auto;
    display: block;
    height: 85%;
    padding-top:2.5%;
    padding-bottom: 2.5%;
}
.Layout-Nav-Logo-Show{
    width: 80%;
    display: block;
    height: auto;
    position:absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
    margin:auto;
    z-index: 10;
}
.Layout-Nav-Irem-Icon{
    font-size: 18px;
    margin-right: 10px;
    line-height: 50px;
}
.el-menu-item:hover{
    background-color: #1f2c39 !important;
}
.Dashboard-Title{
    font-size:20px;
    font-weight: bold;
}
.Menu-Group{
    background-color: #028ce9 !important;
}
.but {
  font-size: 20px;
  /*margin-left: 20px;*/
  line-height: 10vh;
  color: #ffffff;
}
.icon-gaojin {

}
</style>
